export const isset = (...callbacks) => {

    return Array.prototype.slice.call(callbacks).every((accessor) => {

        if (typeof accessor !== 'function') {
            throw new TypeError('isset requires accessors to be functions')
          // eslint-disable-next-line no-unreachable
        } else {
            try {
                const value = accessor();

                return value !== undefined && value !== null
            } catch (e) {
                return false
            }
        }
    });
}
